module.exports = __webpack_public_path__ + "static/media/28-skikkelig.ce282d44.mp3";